module.exports = __webpack_public_path__ + "static/media/10.cf57e520.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/10.jpg
// module id = 700
// module chunks = 0